module.exports = __webpack_public_path__ + "img/20180815_151844_203.371ed029.jpg";